import _L, { _HttpMsg } from "../utils/Labels";
import { _GetUserInfo, _InitSession, _SetInfoUser, _SignOut, _ValidateSession } from "../data/services/UserInfo";
import { _Logout } from "../utils/Device";
import { _RestartAndCreateDB } from "../data/utils/General";
import { ShowToast } from "../ui/components/Toast";

let isLoading = false;

export const authService = {
    logIn: (user: string, pass: string, showToast = true): Promise<IUsuario | null> => {
        isLoading = true;
        return new Promise<IUsuario | null>((resolve) => {
            _InitSession(user, pass, (userData, status) => {
                isLoading = false;
                if (status === 1 && userData) {
                    resolve(userData);
                } else {
                    showToast && ShowToast(_L("login.login"), _HttpMsg("grupo/LoginV4", status), 'error');
                    resolve(null);
                }
            });
        })
    },
    signOut: (): Promise<boolean> => {
        isLoading = true;
        return new Promise<boolean>((resolve) => {
            _SignOut((resultCode) => {
                isLoading = false;
                resolve(resultCode === 1);
            });
        });
    },
    logOut: async (showToast = false): Promise<void> => {
        const successSignOut = await authService.signOut();
        if (!successSignOut) {
            showToast && ShowToast(_L("sesion.logout"), _L("sesion.logout_fail"), "error");
            return;
        }
        await _RestartAndCreateDB();
        _Logout();
    },
    getUserInfo: async (): Promise<IUsuario | null> => {
        const userInfo = await _GetUserInfo();
        return userInfo;
    },
    setUserInfo: (info: IUsuario): Promise<any> => {
        return _SetInfoUser(info);
    },
    isAuthenticated: (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            _ValidateSession((status) => {
                resolve(status > 0);
            })
        })
    },
    validateSession: async (): Promise<void> => {
        const isAuthenticated = await authService.isAuthenticated();
        if (isAuthenticated) return;
        authService.logOut();
    },
    isLoading: (): boolean => {
        return isLoading;
    }
}